import { alpha, lighten } from '@mui/material';

const DARK_CONTAINER_ALPHA = 0.16;
const DARK_ICON_LIGHTEN = 0.3;

// Light mode uses a pale containerColor tint + saturated iconColor; on dark the pale fill leaks
// near-white. Derive a low-alpha tint of the icon color as the container + a lightened icon color.
const getDarkContainerColor = iconColor => alpha(iconColor, DARK_CONTAINER_ALPHA);
const getDarkIconColor = iconColor => lighten(iconColor, DARK_ICON_LIGHTEN);

export const getTitleContainerIconStyles = ({ iconColor, containerColor }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  height: '24px',
  borderRadius: '100%',
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? getDarkContainerColor(iconColor) : containerColor,
  color: ({ palette }) => (palette.mode === 'dark' ? getDarkIconColor(iconColor) : iconColor),
});
